import { addAuthorizationToHeader } from "./authorize";
import { BASE_PATH } from "./base";
const GET_ALL_RESOURCES_PATH = BASE_PATH + "/get-all-resources";
export const getAllResources = async () => {
    const headers = new Headers();
    addAuthorizationToHeader(headers);
    return fetch(GET_ALL_RESOURCES_PATH, {
        method: "GET",
        headers,
    }).then((response) => response.json());
};
